import { Button, Grid, Typography, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import React, { useState, useEffect, Fragment } from "react";
import useErrorCatcher from "utils/useErrorCatcher";
import { Misc } from "services";
import { ErrorMessage } from "components";

const useStyles = makeStyles(theme => ({
  root: {
    height: "100%",
    justifyContent: "stretch",
    display: "flex",
    flexDirection: "column"
  },
  cardgrid: {
    marginTop: theme.spacing(3),
    flex: 1,
  },
  card: {
    flex: 1,
    alignItems: "stretch"
  },
  content: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  downloadTitle: {
    marginBottom: 30
  }
}));

let mounted = false
const Header = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [appVersion, setAppVersion] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const errorCatcher = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    errorCatcher(async () => {
      const version = await Misc.appversion();
      if (mounted)
        setAppVersion(version);
    });

    return () => mounted = false;
  }, []); // eslint-disable-line

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <ErrorMessage message={errorMessage} />
      <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
        <Grid item>
          <Typography component="h2" gutterBottom variant="overline">Mobile App Download</Typography>
        </Grid>
        <Grid item>
          {appVersion && (
            <Button color="primary" component="a" href={appVersion.link} variant="contained">
              Download APK
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid className={classes.cardgrid} container>
        <Card className={classes.card}>
          <CardContent className={classes.content}>
            {appVersion && (
              <Fragment>
                <Typography component="h1" gutterBottom variant="h3">Current Version: {appVersion.name} ({appVersion.code})</Typography>
                <Typography variant="subtitle1" className={classes.downloadTitle}>APK Download Link:</Typography>
                {appVersion.link && <QRCode size={300} value={appVersion.link} />}
              </Fragment>
            )}
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string
};

Header.defaultProps = {};

export default Header;
